import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';;
import { Injectable } from '@angular/core';
import { API_URL } from '../../configurations/server-config';
const headers: any = new HttpHeaders({
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*'
});
@Injectable({
  providedIn: 'root'
})
export class CollisService {
  constructor(private http: HttpClient) { }

  saveCollis(collis: any): any {
    return this.http.post(`${API_URL}/createcollis`, collis, {
      observe: 'response',
    });
  }

  updateCollis(collis: any, idcollis: any, code: string = ''): any {
    const agParam = code ? `&a=${encodeURIComponent(code)}` : '';
    return this.http.put(`${API_URL}/updatecollis?idcollis=${encodeURIComponent(idcollis)}${agParam}`, collis);
  }

  changeReceiver(idcollis: string, body: any, code: string): any {
    return this.http.put(`${API_URL}/change-receiver?idcollis=${encodeURIComponent(idcollis)}&a=${encodeURIComponent(code)}`, body);
  }

  updateCollisPicture(picture: string, idcollis: string): any {
    return this.http.put(`${API_URL}/updatecollis/picture?idcollis=${encodeURIComponent(idcollis)}`, { picture });
  }

  updateCollisSignature(signature: string, idcollis: string): any {
    return this.http.put(`${API_URL}/updatecollis/signature?idcollis=${encodeURIComponent(idcollis)}`, { signature });
  }
  // get list of all colis
  getAllCollis(page= 0, size= 10, sortby: any=null, orderby: any=null): any {
    return this.http.get(`${API_URL}/collis?page=${page}&size=${size}&sortby=${sortby}&direction=${orderby}`);
  }

  // get list of retrait colis
  getAllColisretrait(page= 0, size= 10, sortby: any=null, orderby: any=null): any {
    return this.http.get(`${API_URL}/collisretrait?page=${page}&size=${size}&sortby=${sortby}&direction=${orderby}`);
  }
  // get collis by destination
  getcollisbydestiantion(id: any, page= 0, size= 50): any {
    return this.http.get(`${API_URL}/collisbydestination/${id}?page=${page}&size=${size}`);
  }
// get collis by destination and status
  getcollisbydestiantionstatus(id: any, page= 0, size= 10): any {
    return this.http.get(`${API_URL}/collisbydestinationstatus/${id}?page=${page}&size=${size}`);
  }

  getcollisbystatus(page= 0, size= 10): any {
    return this.http.get(`${API_URL}/collisbystatus?page=${page}&size=${size}`);
  }

  removecollisfrombordereau(coll: any): any {
    return this.http.post(`${API_URL}/updatecollisstatus`, coll);
  }

  receptioncollis(coll: any): any {
    return this.http.post(`${API_URL}/receptioncollis`, coll);
  }

  getcollisdetails(coll: any): any {
    return this.http.get(`${API_URL}/getcollisbyid?idcollis=${encodeURIComponent(coll)}`);
  }

  retraitCollis(retrait: { idcollis: any; idreceiver: any; comment: any; idcardnumber: any; }): any {
    return this.http.post(`${API_URL}/retraitcollis`, retrait);
  }

  getcollisinsession(session: any): any {
    return this.http.get(`${API_URL}/collissession/${session}`);
  }

  getamountinsession(session: any): any {
    return this.http.get(`${API_URL}/amountsession/${session}`);
  }

  getColisAmountsByPaymentMethod(session: any): any {
    return this.http.get(`${API_URL}/session/colis-amounts-by-payment?session=${session}`);
  }

  getallcollisinSession(session: any, page: any, size: any): any {
    return this.http.get(`${API_URL}/collisinsessions/${session}?page=${page}&size=${size}`);
  }

  getcolislogs(page: any, size: any): any {
    return this.http.get(`${API_URL}/colislog?page=${page}&size=${size}`);
  }

  searchsender(name: string): any{
    return this.http.post(`${API_URL}/collis/searchsen?q=${name}`, null);
  }

  searchExternalsender(name: string): any{
    return this.http.post(`${API_URL}/collis/searchexternalsen?q=${name}`, null);
  }

  searchsenderwithsavecolissatus(name: string,destination: any=null): any{
    return this.http.post(`${API_URL}/collis/searchsenwithsavestatus?q=${name}&dest=${destination}`, null);
  }

  searchsennum(name: string): any{
    return this.http.post(`${API_URL}/collis/searchsennum?q=${name}`, null);
  }

  getChefCourrierStats(startDate?: string, endDate?: string, code?: string): any {
    let params = new HttpParams();
    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }
    if (code) {
      params = params.set('a', code);
    }
    return this.http.get(`${API_URL}/chefcourrierdashboard`, { params });
  }

  searchExternalsennum(name: string): any{
    return this.http.post(`${API_URL}/collis/searchexternalsennum?q=${name}`, null);
  }

  searchreceiver(name: string): any{
    return this.http.post(`${API_URL}/collis/searchreceiver?q=${name}`, null);
  }

  searchcolisByExternalreceiver(name: string): any{
    return this.http.post(`${API_URL}/collis/searchexternalreceiver?q=${name}`, null);
  }

  searchreceiverwithsavecolisstatus(name: string,destination: any): any{
    return this.http.post(`${API_URL}/collis/searchreceiverwithsavecolisstatus?q=${name}&dest=${destination}`, null);
  }

  searchreceivernum(name: string): any{
    return this.http.post(`${API_URL}/collis/searchreceivernum?q=${name}`, null);
  }

  searchExternalreceivernum(name: string): any{
    return this.http.post(`${API_URL}/collis/searchexternalreceivernum?q=${name}`, null);
  }

  searchreceivernumWithSaveColisStatus(name: string,destination: any): any{
    return this.http.post(`${API_URL}/collis/searchreceivernumwithsavestatus?q=${name}&dest=${destination}`, null);
  }

  searchDescriptionWithSaveColisStatus(name: string,destination: any): any{
    return this.http.post(`${API_URL}/collis/searchdescriptionwithsavecolisstatus?q=${name}&dest=${destination}`, null);
  }

  searchticket(name: string): any{
    return this.http.post(`${API_URL}/collis/searchticket?q=${name}`, null);
  }

  searchExternalticket(name: string): any{
    return this.http.post(`${API_URL}/collis/searchexternalticket?q=${name}`, null);
  }

  searchticketwithsavestatus(name: string,destination: any=null): any{
    return this.http.post(`${API_URL}/collis/searchticketsave?q=${name}&dest=${destination}`, null);
  }

  // customer services
  searchcustomerbynumber(name: string): any{
    return this.http.post(`${API_URL}/customer/searchnumber?q=${name}`, null);
  }

  getReceiverProfile(phone: string): any {
    return this.http.get(`${API_URL}/customer/receiver-profile?phone=${encodeURIComponent(phone)}`);
  }

  searchcustomerbyname(name: string): any{
    return this.http.post(`${API_URL}/customer/searchname?q=${name}`, null);
  }

  searchdescription(name: string): any{
    return this.http.post(`${API_URL}/description?q=${name}`, null);
  }

  searchbyColisStatusAndDate(status: any = null, date: any = null): any {
    return this.http.post(`${API_URL}/bordereau/searchdatestatus?q=${status}&d=${date}`, null);
  }

  getcolisdate(): any{
    return this.http.get(`${API_URL}/getcolisdate`);
  }

  quickedit(data: any): any{
    return this.http.post(`${API_URL}/quickedit`, data);
  }

  cancelticket(idcollis: any): any {
      return this.http.post(`${API_URL}/cancelmailticket?id=${idcollis}`, null);
  }

  getColisSummarySession(session: any){
    return this.http.get(`${API_URL}/colissummary?id=${session}`);
  }

  getColisSummaryByTarif(session: any): any {
    return this.http.get(`${API_URL}/colissummarybytarif?id=${session}`);
  }

  updateComment(id: any,comments: any): any {
    return this.http.post(`${API_URL}/updatecomment`, {idcollis: id,comment: comments});
  }

  /**
   * Get parcels by bus and month for export
   * @param bus Bus immatriculation/plate number
   * @param year Year (e.g., 2026)
   * @param month Month (1-12)
   */
  getCollisByBusAndMonth(bus: string, year: number, month: number): any {
    return this.http.get(`${API_URL}/collis/bus-month?bus=${bus}&year=${year}&month=${month}`);
  }

  getClaimedParcels(page = 0, size = 10): any {
    return this.http.get(`${API_URL}/collis/claims?page=${page}&size=${size}`);
  }

  resolveClaim(id: any, claim: any): any {
    return this.http.post(`${API_URL}/collis/claims/resolve?idcollis=${encodeURIComponent(id)}`, claim);
  }

  getParcelStatusInfo(status: string) {
    const s = (status || '').toLowerCase().trim();
    switch (s) {
      case 'sauvegarde':
        return {
          icon: 'fa-envelope-open-text',
          class: 'status-sauvegarde',
          title: 'Sauvegarde'
        };
      case 'transit':
        return {
          icon: 'fa-shipping-fast',
          class: 'status-transit',
          title: 'En transit'
        };
      case 'ptransit':
        return {
          icon: 'fa-shipping-fast blink',
          class: 'status-ptransit',
          title: 'Partiellement Envoye'
        };
      case 'reception':
        return {
          icon: 'fa-sms',
          class: 'status-reception',
          title: 'Receptionner'
        };
      case 'preception':
        return {
          icon: 'fa-sms',
          class: 'status-preception',
          title: 'Receptionner'
        };
      case 'cancel':
        return {
          icon: 'fa-window-close',
          class: 'status-cancel',
          title: 'Annuler'
        };
      case 'missing':
        return {
          icon: 'fa-exclamation-triangle',
          class: 'status-missing',
          title: 'Perdu / Missing'
        };
      case 'broken':
        return {
          icon: 'fa-heart-broken',
          class: 'status-broken',
          title: 'Cassé / Broken'
        };
      case 'not_yet_seen':
        return {
          icon: 'fa-eye-slash',
          class: 'status-not-yet-seen',
          title: 'Pas encore vu'
        };
      default:
        return {
          icon: 'fa-handshake',
          class: 'status-default',
          title: 'Livrer'
        };
    }
  }

  getCriteriaSearch(criteria: any, page = 0, size = 10, sort = 'creationdate', direction = 'desc'): any {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort)
      .set('direction', direction);
      
    Object.keys(criteria).forEach(key => {
      if (criteria[key] !== null && criteria[key] !== undefined && criteria[key] !== '') {
        params = params.set(key, criteria[key]);
      }
    });

    return this.http.get(`${API_URL}/collis/criteria`, { params });
  }

}